export default __webpack_public_path__ + "7db0d05823f37bfaea85f57b0121afb2.png";